import copy from 'clipboard-copy';
import React, { Component } from 'react';
import { Container } from 'react-bootstrap';
import DoneAndFavoriteCards from '../components/DoneAndFavoriteCards';
import FilterButtons from '../components/FilterButtons';
import HeaderLocation from '../components/Header';

class ReceitasFavoritas extends Component {
  constructor() {
    super();
    this.state = {
      recipes: [],
      filter: 'all',
      displayShareMesage: false,
    };
    this.share = this.share.bind(this);
    this.changeFilter = this.changeFilter.bind(this);
    this.updateFavoriteItems = this.updateFavoriteItems.bind(this);
  }

  componentDidMount() {
    this.updateFavoriteItems();
  }

  updateFavoriteItems() {
    const list = JSON.parse(localStorage.getItem('favoriteRecipes')) || [];
    this.setState({ recipes: list });
  }

  changeFilter(type) {
    return this.setState({ filter: type });
  }

  share(obj) {
    const location = `http://localhost:3000/${obj.type}s/${obj.id}`;
    copy(location);
    const SHOW_TIME_MILISECONDS = 3000;
    this.setState({ displayShareMesage: true }, () => {
      setTimeout(() => this.setState(
        { displayShareMesage: false },
      ), SHOW_TIME_MILISECONDS);
    });
  }

  render() {
    const { filter, displayShareMesage, recipes } = this.state;
    return (
      <div className="page-wrapper-custom">
        <HeaderLocation title="Receitas Favoritas" />
        <Container>
          <div className="text-center mt-4">
            <h2 style={{ fontFamily: 'var(--font-display)', fontWeight: 800, fontSize: '2rem', color: 'var(--color-text)' }}>
              ❤️ Suas Favoritas
            </h2>
            <p style={{ color: 'var(--color-text-muted)', fontSize: '0.95rem' }}>
              Acesse rapidamente os pratos e drinks que ganharam o seu coração.
            </p>
          </div>

          <FilterButtons changeFilter={ this.changeFilter } />

          { displayShareMesage && (
            <div className="share-toast mx-auto my-3" role="status" aria-live="polite">
              ✨ Link copiado para a área de transferência!
            </div>
          )}

          <DoneAndFavoriteCards
            recipes={ recipes || [] }
            filter={ filter }
            share={ this.share }
            updateFavoriteItems={ this.updateFavoriteItems }
          />
        </Container>
      </div>
    );
  }
}

export default ReceitasFavoritas;
